import { useEffect, useState } from 'react'

function ErrorUp({ message, removeMessage }) {
  const [display, setDisplay] = useState('flex')
  const [error, setError] = useState(null)


  useEffect(() => {
    setError(message)
    const timeout = setTimeout(() => {
      setDisplay('none')
      removeMessage(null)
    }, 2500)
    return () => clearTimeout(timeout)
  }, [message])

  return (
    <div className='message' style={{ display: display }}>
      <div className='h6' style={{ backgroundColor: '#ff9696', color: '#ff1a1a' }}>{error}</div>
    </div>
  )
}

export default ErrorUp;